//
//
//
//
//
//
//
//
//

export default {
  name: "SitisImg",

  props: {
    src: {
      type: String,
      default: '0',
    },
    width: {
      type: [Number, String],
      default: '',
    },
    height: {
      type: [Number, String],
      default: '',
    },
    fit: {
      type: String,
      default: 'default',
    },
    alt: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    loading: {
      type: String,
      default: 'lazy'
    },
    border: {
      type: [String, Number],
      default: '',
    },
    quality:{
      type: String,
      default: '',
    },
    format:{
      type: String,
      default: '',
    },
    background:{
      type: String,
      default: '',
    },
    modifiers: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    setLinks() {
      let modifier = {...this.modifiers};
      let doubleModifier = {...this.modifiers};

      if(this.border){
        modifier.border = this.border;
        doubleModifier.border = this.border;
      }

      if(typeof this.quality ==='string' && this.quality.length){
        modifier.quality = this.quality;
        doubleModifier.quality = this.quality;
      }

      if(typeof this.format ==='string' && this.format.length){
        modifier.format = this.format;
        doubleModifier.format = this.format;
      }

      if(this.width && this.width !== '0'){
        modifier.width = Number(String(this.width).replace(/\D+/g,""));
        doubleModifier.width = Number(String(this.width).replace(/\D+/g,"")) * 2;
      }

      if(this.height && this.height !== '0'){
        modifier.height = Number(String(this.height).replace(/\D+/g,""));
        doubleModifier.height = Number(String(this.height).replace(/\D+/g,"")) * 2;
      }

      if(this.background && this.background.length && typeof this.background ==='string'){
        modifier.background = this.background;
        doubleModifier.background = this.background;
      }

      const defaultLink = this.$img(String(this.src), {
        fit: this.fit,
        loading: this.loading,
        ...modifier
      });

      const doubleSizeLink = this.$img(String(this.src), {
        fit: this.fit,
        loading: this.loading,
        ...doubleModifier
      });

      return {
        defaultLink, doubleSizeLink: `${doubleSizeLink}`
      }
    }
  },
}
